export default {
    BENEFIT_STORE_COMMON_URL: process.env.VUE_APP_BENEFIT_STORE_COMMON_URL
}